import { Component, Input, OnDestroy, Optional, Self, ViewChild, ElementRef } from "@angular/core";
import { NgControl } from "@angular/forms";
import { Deferred } from '../../../../modules/tcm-core.module';
import { TextInputComponent } from "../../../../modules/tcm-form/controls/text-input/text-input.component";

@Component({
    selector: 'copyable-text-input',
    templateUrl: './copyable-text-input.component.html',
    inputs: ['label', 'disabled', 'hideValidationMessages', 'isReadonlyValue', 'placeholder', 'tabindex'],
    styleUrls: ['copyable-text-input.component.scss'],
    standalone: false
})
export class CopyableTextInputComponent extends TextInputComponent implements OnDestroy {

  @Input() override maxLength: number;
  @Input() city: string;
  @Input() searchInAllCountries: boolean;
  @ViewChild('copyableInput') input: ElementRef;

  private _controlCancellationTokenDeferred: Deferred;

  constructor(@Self() @Optional() protected override ngModel: NgControl) {
    super(ngModel)

    this._controlCancellationTokenDeferred = new Deferred();
  }

  ngOnDestroy() {
    this._controlCancellationTokenDeferred.resolve();
  }

  copy() {
    this.input.nativeElement.select();
    document.execCommand("copy");
  }
}